import type { ShapeManagerRef } from '@/lib/shapes/types/shape-manager-ref'

/** Canvas-space union of path bounds for the current selection (axis-aligned). */
function unionSelectionCanvasBounds(
  mgr: ShapeManagerRef
): { x: number; y: number; width: number; height: number } | null {
  const ids = mgr.getSelectedShapeIds()

  if (ids.length === 0) return null

  const shapes = mgr.getShapes()
  let minX = Infinity
  let minY = Infinity
  let maxX = -Infinity
  let maxY = -Infinity

  for (const id of ids) {
    const shape = shapes.find((s) => s.id === id)

    if (!shape || shape.hidden) continue

    const lb = mgr.getShapeBounds(id)
    const x = shape.x + (lb?.x ?? 0)
    const y = shape.y + (lb?.y ?? 0)
    const w = lb?.width ?? shape.width ?? 0
    const h = lb?.height ?? shape.height ?? 0

    minX = Math.min(minX, x)
    minY = Math.min(minY, y)
    maxX = Math.max(maxX, x + w)
    maxY = Math.max(maxY, y + h)
  }

  if (!Number.isFinite(minX)) return null

  return { x: minX, y: minY, width: maxX - minX, height: maxY - minY }
}

/** Shape selection in canvas space; null if nothing is selected. */
export function combinedSelectionCanvasBounds(
  shapeMgr: ShapeManagerRef | null
): { x: number; y: number; width: number; height: number } | null {
  return shapeMgr ? unionSelectionCanvasBounds(shapeMgr) : null
}
